<template>
  <td v-if="symbol.sector && symbol.sector !== '-'">
    <div class="content">
      <div class="linkable"  @click="openFloatingSymbolsList(`/symbols/filter?sector=${encodeURIComponent(symbol.sector)}`, symbol.sector)"/>
      {{ symbol.sector }}
    </div>
  </td>
  <td class="center" v-else>-</td>


  <td v-if="symbol.industry && symbol.industry !== '-'">
    <div class="content">
      <div class="linkable" @click="openFloatingSymbolsList(`/symbols/filter?industry=${encodeURIComponent(symbol.industry)}`, symbol.industry)"/>
      {{ symbol.industry }} <i class="ri-external-link-line"></i>
    </div>
  </td>
  <td class="center" v-else>-</td>
</template>

<script>

import eventBus from "../../services/events";
export default {
  name: "IndustrySectorCell",
  props: ['symbol'],
  methods: {
    openFloatingSymbolsList (endpoint, title) {

      eventBus.emit('floatingSymbolsList', {endpoint, title})
    }
  }
}
</script>

<style scoped lang="scss">

.content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  position: relative;
  width: fit-content;
      color: var(--highlightColor) !important;

  .linkable {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;

    border-bottom: 2px dotted var(--highlightColor) !important;
  }
}
</style>
